import { clsx } from "@trydig/ui";
import { Skeleton } from "@/components/ui/Skeleton";
import { formatProductPrice } from "@/lib/utils";
import styles from "./ProductPrice.module.css";

export interface ProductPriceProps {
	discountedPrice: string;
	price: string;
	className?: string;
}

export const ProductPrice = ({
	discountedPrice,
	price,
	className,
}: ProductPriceProps) => {
	const hasDiscount = price !== discountedPrice;

	return (
		<div className={clsx(styles.root, className)}>
			<span data-invalid-price={hasDiscount} className={styles.price}>
				{formatProductPrice(price)}
			</span>
			{hasDiscount && (
				<span data-discount-price className={styles.price}>
					{formatProductPrice(discountedPrice)}
				</span>
			)}
		</div>
	);
};

export const ProductPriceSkeleton = () => {
	return (
		<div className={styles.root}>
			<Skeleton fitContent>
				<span className={styles.price}>lorem ipsum</span>
			</Skeleton>
		</div>
	);
};
